import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJournal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 65,
	height: 64,
	viewBox: "0 0 65 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0276 57.3308V7.52757H47.2481V18.8465H51.7757V3H6.5V61.8584H51.7757V50.5395H47.2481V57.3308H11.0276Z",
			fill: "#005AA0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8193 21.1101H40.4572V16.5825H17.8193V21.1101Z",
			fill: "#005AA0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8193 30.1653H40.4572V25.6377H17.8193V30.1653Z",
			fill: "#005AA0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8193 39.2204H33.6658V34.6929H17.8193V39.2204Z",
			fill: "#005AA0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.6104 52.8032H40.4568V48.2756H24.6104V52.8032Z",
			fill: "#005AA0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M40.1003 52.7859H41.038L64.4998 29.3241L54.8954 19.7197L31.4336 43.1815V52.7859H40.1003ZM35.9611 45.0569L54.8953 26.1227L58.0968 29.3241L39.1626 48.2583H35.9611V45.0569Z",
			fill: "#005AA0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M51.5811 26.7698L57.984 33.1727L54.7825 36.3742L48.3796 29.9712L51.5811 26.7698Z",
			fill: "#005AA0"
		})
	]
});
const ForwardRef = forwardRef(SvgJournal);
export { ForwardRef as ReactComponent };
